module.exports = __webpack_public_path__ + "static/media/invoice-arrow.31488f6b.svg";